<template>
  <div>
    <div class="pageContent wider">
      <ProgressBar :value="15" />
      <div class="system-header">
        <div class="system-header-image">
          <img src="/img/magic-clipboard@2x.png" alt="Clipboard" />
        </div>
        <div>
          <div class="pageTitle">
            Here's your
            <br />recommended system
          </div>
          <div>
            <div class="text-bold">Our recommendations for</div>
            <div>{{ address }}</div>
          </div>
        </div>
      </div>

      <EquipmentSummary :equipment.sync="equipment" @change="handleEquipmentChange" />

      <!-- <div class="window-protection-card">
        <div>
          <img src="/img/icon-open-window.png" alt="Open Window" />
        </div>
        <div class="content">
          <div class="text-bold">Consider adding window protection</div>
          <div>Ranch style homes like yours typically have easily accessible windows. We recommend considering some forms of window protection.</div>
        </div>
        <div class="link-section">
          <router-link to="/window-protection">Add window protection</router-link>
        </div>
      </div>-->
    </div>

    <ModuleCardGrid />
    
    <div class="continue-section">
      <continue-button text="Continue" to="/system-and-monitoring" />
      <ModuleNeedHelp />
    </div>
  </div>
</template>

<script>
import ModuleCardGrid from "../components/ModuleCardGrid.vue";
import EquipmentSummary from "../components/EquipmentSummary.vue";
import ProgressBar from "../components/ProgressBar.vue";
import ModuleNeedHelp from "../components/ModuleNeedHelp.vue";

export default {
  components: {
    EquipmentSummary,
    ProgressBar,
    ModuleNeedHelp,
    ModuleCardGrid,
  },
  data: () => ({
    system: {
      equipment: {
        cameras: [],
        essential: [],
        homeAutomation: [],
        environmental: []
      }
    },
    address: ``
  }),
  computed: {
    equipment() {
      return this.system.equipment;
    }
  },
  methods: {
    async updateSystem() {
      let { data } = await this.$axios.get("/ajax/system");
      
      this.system = data;
      this.address = this.$store.state.lead.addressFormatted;
    },

    async handleEquipmentChange({ id, price, quantity }) {
      await this.$store.dispatch('setCartItem', {
        id,
        price,
        quantity
      })

      await this.$store.dispatch('save')

      await this.updateSystem()
    }
  },
  async mounted() {
    this.updateSystem();
  }
};
</script>

<style lang="scss" scoped>
.pageContent {
  padding: 3rem 1rem;
  min-height: 90vh;
  max-width: 850px;
}
.system-header {
  display: flex;
  align-items: center;
  margin-bottom: 4rem;
  @media (max-width: 480px) {
    margin-bottom: 2rem;
  }
  img {
    display: block;
    max-width: 115px;
    margin-right: 2.5rem;
  }
  .system-header-image {
    @media (max-width: 480px) {
      display: none;
    }
  }
}

.window-protection-card {
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  display: flex;
  margin: 2.625rem 2rem;
  padding: 2rem;
  font-size: 0.813rem;
  align-items: center;
  line-height: 1.5;

  @media (max-width: 480px) {
    flex-direction: column;
    padding: 1rem;
    text-align: center;
  }

  .content {
    padding: 0 2rem;
    @media (max-width: 480px) {
      padding: 0;
    }
  }
  .link-section {
    flex-shrink: 0;
    @media (max-width: 480px) {
      margin-top: 1rem;
    }
  }
}
</style>

<style src="../../sass/components/continue-section.css" scoped></style>
